const style = {
  root: {
    textDecoration: 'none',

    '&:hover': {
      textDecoration: 'none',
    },
  },
  text: {
    color: '#707070',
    fontSize: '13px',
    marginLeft: '5px',
    fontStyle: 'inherit',
    fontWeight: 400,
  },
};
export default style;
